/** The task date picker and the task pocket's Schedule row. */
export default {
  today: "Today",
  tomorrow: "Tomorrow",
  thisWeekend: "This weekend",
  nextWeek: "Next week",
  morning: "Morning",
  afternoon: "Afternoon",
  evening: "Evening",
  time: "Time",
  customTime: "Custom time",
  removeTime: "Remove time",
  repeat: "Repeat",
  removeRepeat: "Remove repeat",
  goToToday: "Go to today",
  previousMonth: "Previous month",
  nextMonth: "Next month",
  back: "Back",
  clearDate: "Clear date",
  repeatDaily: "Every day",
  repeatWeekdays: "Every weekday (Mon – Fri)",
  repeatWeekly: "Every week on {day}",
  repeatBiweekly: "Every 2 weeks on {day}",
  repeatMonthly: "Every month on day {day}",
  saveFailed: "Failed to save schedule",
  saving: "Saving…",
  schedule: "Schedule",
  add: "Add",
  paused: "Paused",
  nextRun: "Next run {when}",
  runs: { one: "{count} run", other: "{count} runs" },
  lastRun: "last {when}",
  pauseSchedule: "Pause schedule",
  resumeSchedule: "Resume schedule",
} as const;
